let counter = 10000;
let initialState = {
  message: '',
  type: '',
  title: '',
  id: counter,
  notifications: [],
  lastId: 0,
  unreadCount: 0,
};
const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'API_ERROR': {
      const message = action.payload || 'Unexpected Error';

      return Object.assign({}, state, {
        message: message,
        type: 'error',
      });
    }
    case 'SHOW_NOTIFICATION': {
      return Object.assign({}, state, {
        message: action.payload.message,
        type: action.payload.type,
        id: action.payload.id || counter++,
        title: action.payload.title || '',
        notificationData: action.payload.notificationData,
      });
    }
    case 'NOTIFICATIONS': {
      let lastId = state.lastId;
      let unreadCount = state.unreadCount;
      action.payload.forEach((e) => {
        if (parseInt(e.id) > parseInt(lastId)) lastId = e.id;
        if (!e.read) unreadCount++;
      });
      return Object.assign({}, state, {
        notifications: action.payload.concat(state.notifications),
        lastId,
        unreadCount,
        message: '',
        title: '',
        type: '',
      });
    }
    case 'MARK_READ': {
      let unreadCount = state.unreadCount;
      const notifications = state.notifications.map((e) => {
        if (action.payload.includes(e.id)) {
          unreadCount--;
          return { ...e, read: true };
        }
        return e;
      });
      return Object.assign({}, state, { notifications, unreadCount });
    }

    case 'LOGOUT': {
      return initialState;
    }
    default:
      return state;
  }
};
export default notificationReducer;
